import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, ContainerFormRight, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertTestimonialData, updateTestimonialData } from '../../api/testimonials.api'

export const AddTestimonial = () => {
  const { config, config2 } = useAuth();
  const { fetchTestimonialList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ file, setFile ] = useState(null);
  const testimonial = location?.state?.data;
  const formik = useFormik({
    initialValues: {
    testimonial_heading: testimonial?.testimonial_heading,
    testimonial_sub_heading: testimonial?.testimonial_sub_heading,
    testimonial_content: testimonial?.testimonial_content,
    state_name: testimonial?.state_name,
    },
    onSubmit: async values => {
      // console.log(values, file);
      setLoading(true);
      if (testimonial) {
        const submit = await updateTestimonialData({...values, testimonial_id: testimonial?.testimonial_id, file }, config2);
        setResponse(submit);
        setOpen(true);
        fetchTestimonialList();
        if(submit.status === "success") {
          navigate("/testimonial");
        }
      } else {
        const submit = await insertTestimonialData({...values, file}, config2);
        setResponse(submit);
        fetchTestimonialList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/testimonial");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Testimonial Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="testimonial_heading">Heading:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="testimonial_heading"
            placeholder="Enter Testimonial Heading"
            id="testimonial_heading"
            type="text"
            value={formik.values.testimonial_heading}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="testimonial_sub_heading">Sub Heading:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="testimonial_sub_heading"
            placeholder="Enter Testimonial Sub Heading"
            id="testimonial_sub_heading"
            type="text"
            value={formik.values.testimonial_sub_heading}
            onChange={formik.handleChange}
            />
        </FormGroup><br />
        <FormGroup>
          <InputLabel htmlFor="testimonial_content">Content:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="testimonial_content"
            placeholder="Enter Testimonial Content"
            id="testimonial_content"
            type="text"
            value={formik.values.testimonial_content}
            onChange={formik.handleChange}
            />
        </FormGroup><br />
        <FormGroup>
          <InputLabel htmlFor="file">Testimonial Image:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="file"
            placeholder="Select Image"
            id="file"
            type="file"
            // value={file}
            onChange={(e) => setFile(e.target.files[0])}
          />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/testimonial")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={testimonial?.image_file}
                  alt={testimonial?.image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={testimonial?.image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
    </Container>
    </>
  )
};
